module.exports = {"pathContext":{"name":"UpdateAppointmentPositionsResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"message","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":"Result of update appointment positions","isDeprecated":false,"name":"success","type":{"kind":"SCALAR","name":"Boolean","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-update-appointment-positions-result.json
// module id = 2078
// module chunks = 94934183948772